import { User } from 'oidc-client-ts';

import { userKey } from '@/config/oidc';

export function getOidcUser() {
  try {
    const oidcStorage = localStorage.getItem(userKey);
    if (!oidcStorage) return null;

    return User.fromStorageString(oidcStorage);
  } catch (error) {
    console.warn('[OIDC] Failed to parse user from localStorage:', error);
    return null;
  }
}

export function getOidcAccessToken() {
  return getOidcUser()?.access_token ?? '';
}
